import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { SaleTaxComponent } from './saletax.component';
import { CalendarModule, CheckboxModule, AutoCompleteModule, GrowlModule } from 'primeng/primeng';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '../../core/core.module';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule
  ],
  declarations: [
    SaleTaxComponent
  ]
})
export class SaleTaxModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.module.ts